import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { searchUtils } from '../../utils'
import keywords from '../../keywords'
import './ActiveFilters.sass'


class ActiveFilters extends Component {
  constructor() {
    super()
    this._renderFilterTags = this.renderFilterTags.bind(this)
    this._deleteFilterCheckbox = this.deleteFilterCheckbox.bind(this)
  }

  deleteFilterCheckbox({ filter_type, filter_terms }) {
    const { setActiveFilterIds, activeFilterIds } = this.props
    const updatedActiveFilterIds = searchUtils.excludeIdsForFilter(activeFilterIds, filter_terms, filter_type)

    setActiveFilterIds(updatedActiveFilterIds)
  }

  renderFilterTags(activeFilters) {
    return activeFilters.map(activeFilter => (
      <span key={activeFilter.id} className="filter-tag">
        {activeFilter.name}
        <button
          type="button"
          aria-label="close"
          className="delete-btn"
          onClick={() => this._deleteFilterCheckbox(activeFilter)}
        >
          &#10005;
        </button>
      </span>
    ))
  }

  getActiveFilters(filters, activeFilterIds) {
    // Go into each filter (or filter's children if multiselect) and find if any filter IDs are in the active filter ID list
    const activeFitlers = _.flatMap(filters, filterGroup => {
      return filterGroup.filter(filter => {
        // For multiselect, have to check both parent (filter) ID and child (filter term) IDs
        if (filter.filter_type === keywords.multiselect) {
          return filter.filter_terms.some(term => {
            return term.children.some(child => activeFilterIds.includes(child.id)) || activeFilterIds.includes(term.id)
          })
        } else {
          return filter.filter_terms.some(term => activeFilterIds.includes(term.id))
        }
      })
    })

    return activeFitlers
  }

  render() {
    const { filters, setActiveFilterIds, activeFilterIds } = this.props
    const activeFilters = this.getActiveFilters(filters, activeFilterIds)

    if (!activeFilterIds.length) {
      return null
    }

    return (
      <div className="active-filters-container hide-on-mobile">
        <span>Active filters</span>
        {this._renderFilterTags(activeFilters)}
        <button
          type="button"
          className="reset-btn"
          onClick={() => setActiveFilterIds([])}
        >
          RESET ALL FILTERS
        </button>
      </div>
    )
  }
}

ActiveFilters.propTypes = {
  filters: PropTypes.object,
  setActiveFilterIds: PropTypes.func,
  activeFilterIds: PropTypes.array
}

export default ActiveFilters
